import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  computed,
  viewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatIconModule } from '@angular/material/icon';
import { SatPopover, SatPopoverModule } from '@zerops/zef/popover';
import { DynamicPopAnchorModule } from '@zerops/zui/dynamic-pop-anchor';
import { ProjectRole } from '@zerops/models/project';
import { getProjectRoleDisplay } from '@zerops/models/client-user';
import { ZuiTagModule } from '@zerops/zui/tag';

interface MenuAction {
  type: string;
  label: string;
  icon?: string;
}

@Component({
  selector: 'zui-project-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatListModule,
    MatIconModule,
    SatPopoverModule,
    DynamicPopAnchorModule,
    ZuiTagModule
  ],
  templateUrl: './project-chip.component.html',
  styleUrl: './project-chip.component.scss'
})
export class ProjectChipComponent {
  // # Inputs
  projectName = input.required<string>();
  tags = input<string[]>([]);
  roleCode = input.required<ProjectRole>();
  hasChanged = input<boolean>(false);
  menuActions = input<MenuAction[]>([]);

  // # Outputs
  menuAction = output<MenuAction>();

  // # View Children
  menuPopover = viewChild<SatPopover>('menuPopover');

  // # Computed
  #roleDisplay = computed(() => getProjectRoleDisplay(this.roleCode()));

  roleIcon = computed(() => this.#roleDisplay().icon);

  roleLabel = computed(() => this.#roleDisplay().label);

  roleVariant = computed(() => this.#roleDisplay().variant);
}
